var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYahooIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1 2H5.9C3.74609 2 2 3.74609 2 5.9V24.1C2 26.2539 3.74609 28 5.9 28H24.1C26.2539 28 28 26.2539 28 24.1V5.9C28 3.74609 26.2539 2 24.1 2Z",
    fill: "#5F01D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3086 22.5156H9.16016L10.4297 19.5195L6.92578 11.1406H10.125L12.0039 15.9648L13.8828 11.1406H17.0312M19.9766 15H16.4727L19.6211 7.48438H23.125",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3867 19.5703C18.4525 19.5703 19.3164 18.7064 19.3164 17.6406C19.3164 16.5749 18.4525 15.7109 17.3867 15.7109C16.321 15.7109 15.457 16.5749 15.457 17.6406C15.457 18.7064 16.321 19.5703 17.3867 19.5703Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahooIcon);
export default __webpack_public_path__ + "static/media/YahooIcon.39f610ed5927b61642484dc398a10f99.svg";
export { ForwardRef as ReactComponent };